<template>
    <div>
    <loader :show="enviando"/>
    <b-card v-if="!editar">
        <b-button variant="secondary" @click="regresar()"> Regresar </b-button>
          <!-- <div >
            <strong> <h3 > Solicitudes de trabajo </h3></strong>
          </div> -->
        <b-media no-body>
            <b-media-body class="ml-4">
                <div  class="text-right" v-if="puedeAdministrar">
                    <b-button-group>
                        <b-button 
                            size="sm" 
                            :variant="visible ? 'outline-success' : 'outline-secondary'"
                            @click="cambiaVisible()">
                            <i :class="visible ? 'fa fa-lg fa-globe': 'fa fa-lg fa-globe'"></i>
                        </b-button>
                        <b-button 
                            size="sm" 
                            variant="outline-secondary"
                            @click="editarSolicitud()">
                            <i class="fa fa-pencil fa-lg"></i>
                        </b-button>
                        <b-button 
                            size="sm" 
                            variant="outline-secondary"
                            @click="eliminar()">
                            <i class="fa fa-trash fa-lg"></i>
                        </b-button>
                    </b-button-group>
                </div>
                <h5 class="mt-0">
                    {{ titulo }}
                </h5>
                <div v-html="descripcion"></div>
            </b-media-body>
        </b-media>
        </b-card>

                <!--  ========================== EDITAR SOLICITUD  ================================ -->

        <b-card v-if="editar">
            <b-form> 
            <b-form-group id="grupotitulo"  label="Titulo:"  label-for="tituloL" >           
               <b-form-input id="tituloL"
                v-model.trim="tituloTemp"
                type="text"
                placeholder="Ingrese un titulo"
                :class="{invalid_input: $v.titulo.$error}"                       
                ></b-form-input>
                <label v-if="$v.titulo.$error && !$v.titulo.required" 
                id="name-error" class="error" >
                <i>Campo requerido.</i></label>
                <label v-if="$v.titulo.$error && !$v.titulo.minLength" 
                    class="error" >
                <i>Debe tener mínimo 2 caracteres.</i></label>
            </b-form-group>         
            <b-col sm="12" lg="12">&nbsp; </b-col>
        
            <b-col sm="12" lg="12">
                <vue-ckeditor v-model="descripcionTemp"  :config="editorConfig" />
            </b-col>
            <b-col sm="12" lg="12">&nbsp;</b-col>
            <b-col sm="12"  class="text-right">
                <b-button class="mr-1" variant="secondary" @click="editar=false"> Cancelar </b-button>
            
                <b-button class="mr-1" variant="primary" @click="guardar()">  Guardar </b-button>
            </b-col>
       
        </b-form>
         
        </b-card>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from "vuex";
import { required, minLength} from 'vuelidate/lib/validators'
import VueCkeditor from 'vue-ckeditor2';
import Loader from '../Loader'
export default {
  name: 'promocionEconomica',
  
  components: {VueCkeditor, Loader},
  validations: {
       titulo:{ required, minLength: minLength(4) }
    },
  computed: {
    ...mapGetters(["httpURL",  "sessionToken",  "permisos",  "role" ]),
    
    puedeAdministrar(){
        if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 215) >= 0 )
            return true;
        else  return false;
        
    },
    
  },
  created(){
    this.enviando=true;
   
    axios.get(this.httpURL+'/promocionEconomica/promocion/'+this.id,
              {headers: {token:this.sessionToken}})
        .then(res => {
            this.enviando=false;
            //console.log(res.data);
            this.titulo = res.data.promocion.titulo;
            this.descripcion = res.data.promocion.descripcion;
            this.visible=res.data.promocion.visible;
            this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: res.data.mensaje });
        })
        .catch(error => {
           this.enviando=false;
            if(error.response){
                //console.log(error.response);
                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                    text: error.response.data.mensaje });
            }else if( error.request){
                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                    text: 'No se pudo establecer una conexión al servidor.' });
            }
        });
        },
  data: function () {
    return {
        
        id: this.$route.params.id,
       enviando:false,
        editar: false,
        titulo:'',
        descripcion:'',
        visible:false,
        editorSettings: {
          modules: {
            imageDrop: true,
            imageResize: {}
          }
        },
       editorConfig: {
            toolbar: [
                ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript','Image'],
                ['NumberedList','BulletedList','JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock','TextColor','BGColor'],
                ['Link','Table','SpecialChar','Styles','Format','Font','FontSize'],
                ['Cut','Copy','Paste','PasteText','PasteFromWord','Undo','Redo']
            ],
            height: 300
        }
    }
  },
  methods: {
    regresar(){
        this.$router.go(-1);
    },
    editarSolicitud(){
        this.tituloTemp = this.titulo;
        this.descripcionTemp = this.descripcion;
        this.editar = true;
    },
    guardar(){
        this.$v.$touch();
        if (!this.$v.$invalid) {
        this.enviando=true;
        axios.put(this.httpURL+'/promocionEconomica/promocion/'+this.id,
              {
                titulo:this.tituloTemp,
                descripcion:this.descripcionTemp
              },
              {headers: {token:this.sessionToken}})
          .then(res => {
            // console.log(res.data);
            this.editar = false;
            this.enviando=false;
            this.titulo = res.data.promocion.titulo;
            this.descripcion = res.data.promocion.descripcion;
            this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,text: res.data.mensaje });
          })
          .catch(error => {
            this.enviando=false;
              if(error.response){
                  //console.log(error.response);
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                      text: error.response.data.mensaje });
              }
          });
        }
    },
  

    cambiaVisible(){
        this.enviando=true;
           axios.put(this.httpURL+'/promocionEconomica/promocion/visible/'+this.id,
                {},{headers: {token:this.sessionToken}})
            .then(res => {
               // console.log(res.data);
                this.enviando=false;
                if(res.data.ok){
                this.visible = res.data.visible;
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000, text: res.data.mensaje });
                }
            })
            .catch(error => {
                this.enviando=false;
                if(error.response){
                    //console.log(error.response);
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }
            });
    },
    eliminar(){
        this.enviando=true;
           axios.delete(this.httpURL+'/promocionEconomica/promocion/'+this.id,{headers: {token:this.sessionToken}})
            .then(res => {
               // console.log(res.data);
                this.enviando=false;
                if(res.data.ok){
                this.regresar();
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000, text: res.data.mensaje });
                }
            })
            .catch(error => {
                this.enviando=false;
                if(error.response){
                    //console.log(error.response);
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }
            });
    },
    
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

div.show-image {
    position: relative;
    float:left;
    margin:5px;
}
div.show-image:hover img{
    opacity:0.5;
}

div.show-image:hover .edit{
    display: block;
}

.edit {
	padding-top: 0px;	
	padding-right: 0px;
	position: absolute;
	right: 1;
	top: 1;
	display: none;
}

div.show-image .progreso-img{
	padding-top: 0px;	
	padding-right: 0px;
	position: absolute;
    width: 100%;
	
	top: 50%;
	display: block;
}

</style>

<style>
  .quill-editor:not(.bubble) .ql-container,
  .quill-editor:not(.bubble) .ql-container .ql-editor {
    height: 10rem;
    padding-bottom: 1rem;
  }
</style>

<style lang="scss" scoped>